<template>
  <div id="feedback">
    <!-- 顶部导航栏 -->
    <van-nav-bar :title="$t('title.contact_customer_service')" placeholder safe-area-inset-top @click-left="onClickLeft" :right-text="$t('column.save_draft')" @click-right="onClickRight" left-arrow />
    <van-row>
      <!-- 订单号输入 -->
      <van-col span="22" offset="1" v-if="orderNumber">
        <div class="form-label">
          <span class="required">*</span>
          <span>{{ $t('column.order_number') }}</span>
        </div>
        <van-field
            v-model="orderNumber"
            readonly    
            class="order-input"
        />
      </van-col>
      
      <!-- 是否与订单相关 -->
      <van-col span="22" offset="1">
        <div class="form-label">
          <span class="required">*</span>
          <span>{{ $t('column.is_related_to_order') }}</span>
        </div>
        <div class="toggle-buttons">
          <van-button
              :class="{ 'active': !isRelatedToOrder }"
              class="toggle-btn"
              @click="isRelatedToOrder = false"
          >
            {{ $t('column.no') }}
          </van-button>
          <van-button
              :class="{ 'active': isRelatedToOrder }"
              class="toggle-btn"
              @click="isRelatedToOrder = true"
          >
            {{ $t('column.yes') }}
          </van-button>
        </div>
      </van-col>
      
      <!-- 订单列表选择器（当选择yes时显示） -->
      <van-col v-if="isRelatedToOrder" span="22" offset="1">
        <div class="form-label">
          <span>{{ $t('column.order_number') }}</span>
        </div>
        <van-field
            v-model="selectedOrderVaL"
            :placeholder="$t('column.select_order')"
            class="order-select"
            readonly
            @click="showOrderPicker = true"
            is-link
        />
      </van-col>
      
      <!-- 问题描述 -->
      <van-col span="22" offset="1">
        <van-col span="24">
          <van-field
              v-model="message"
              rows="4"
              autosize
              class="feedback_text"
              type="textarea"
              maxlength="500"
              :placeholder="$t('column.please_describe_problem_detail')"
              show-word-limit
          />
        </van-col>
        <van-col span="24">
          <!-- 上传图片 -->
          <van-col span="24">
            <uploadImage
                ref="uploader"
                class="help_form_upload"
                :imageUrl="proof_img"
                :cos-config="cosConfig"
                v-if="iscos"
                @successUploadImage="handleSuccess"
                @errorUploadImage="handleError"
            />
          </van-col>
        </van-col>
        <van-col span="24" class="feedback_title_text">{{ $t('column.please_provide_that_assist_problems')}}</van-col>
        <van-col span="22" offset="1">
          <van-button class="help_form_btn" color="#FF61F5" block round @click="onClickButton">{{ $t('column.submit') }}</van-button>
        </van-col>
      </van-col>
    </van-row>
    
    <!-- 订单选择弹框 -->
    <van-popup v-model="showOrderPicker" position="bottom" style="border-radius: 2vw 2vw 0 0;">

      <van-picker
        show-toolbar
          :columns="orderColumns"
          @confirm="onOrderConfirm"
          @cancel="showOrderPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import Toast from 'vant/lib/toast'
import UploadImage from "./upload_image.vue";
import axios from "axios";
import {Dialog} from "vant";
import '@/assets/css/style.css'

export default {
  components: {
    UploadImage
  },
  data() {
    return {
      message: undefined,
      iscos: false,
      proof_img: undefined,
      type_i: 1,
      orderNumber: '', // 订单号
      isRelatedToOrder: false, // 是否与订单相关
      selectedOrder: '', // 选中的订单
      selectedOrderVaL: '', // 选中的订单值
      orderList: [],
      showOrderPicker: false, // 是否显示订单选择弹框
      cosConfig: {
        tmpSecretKey: undefined,
        tmpSecretId: undefined,
        bucket: undefined,
        region: undefined,
        sessionToken: '',
        domain: '',
      }
    }
  },
  computed: {
    // 订单选择器列数据
    orderColumns() {
      return this.orderList.map(order => ({
        text: `${order.order_id} ($${order.dollar_amount})`,
        value: order.order_id
      }))
    }
  },
  created() {
    this.orderNumber = this.$route.query.order_id || ''
    const list = localStorage.getItem('feedbackStorage');
    if (list) {
      const list_val = JSON.parse(list);
      this.message = list_val.message
      this.type_i = list_val.type_i
      this.proof_img = list_val.proof_img
      console.log('数据已从缓存中恢复');
    }
    this.getcosConfig()
    this.get_recent_orders_list()
  },
  methods: {
    get_recent_orders_list(){
        const uid = this.$route.query.uid
        const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=user_h5&act=get_recent_orders",{
          params:{
            uid: uid,
            token: token
          }
        }).then(res =>{
        console.log(res.data)
        if(res.data.status===1){
          this.orderList = res.data.data
        }
      })
    },
    onClickRight() {
      const list = {
        message: this.message,
        type_i: this.type_i,
        proof_img: this.proof_img
      }
      localStorage.setItem('feedbackStorage', JSON.stringify(list))
      Toast(this.$t('column.saved_successfully'))
    },

    onClickButton() {
      Dialog.confirm({
        title: this.$t('column.are_you_sure_to_submit'),
        confirmButtonColor: '#545AFF',
        confirmButtonText: this.$t('btn.confirm'),
        cancelButtonText: this.$t('btn.cancel'),
      }).then(() => {
        const toast = this.$toast.loading({
          duration: 0, // 持续展示
          forbidClick: true,
          message: this.$t('other.Loading') + '...',
          className: 'custom-loading-toast' // 添加自定义类名
        });
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=user_h5&act=add_feedback",{
          params:{
            uid: uid,
            token: token,
            message: this.message,
            type: this.type_i,
            proof_img: this.proof_img,
            order_id: this.isRelatedToOrder ? this.selectedOrder : '',
            order_text: this.isRelatedToOrder ? this.selectedOrderVaL : ''
          }
        }).then(res =>{
          localStorage.removeItem('feedbackStorage');
          toast.clear(); // 关闭加载提示
          if(res.data.status ===1){
            const ticket_id = res.data.data.ticket_id
            Toast({
              message: res.data.error,
              duration: 2000, // 持续2秒
              onClose: () => {
                const token = this.$route.query.token
                const uid = this.$route.query.uid
                this.$router.push({
                  path: "/feedback_message",
                  query:{ token: token, uid: uid,ticket_id: ticket_id }
                })
              }
            })
          }else{
            Toast(res.data.error)
          }
        })
      })
    },
    getcosConfig(){
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=app&act=getCosSTS",{ params:{ uid: uid, token: token }}).then(res =>{
        console.log(res.data)
        if(res.data.status===1){
          this.cosConfig = res.data.data.sts
          this.iscos = true
        }else{
          this.$emit('errorUploadImage', res.data.error)
        }
      })
    },
    handleSuccess(url) {
      // 上传成功
      console.log('====handleSuccess====')
      console.log(url)
      this.proof_img = url
    },
    handleError(err) {
      console.log('====handleError====')
      // 上传失败
      Toast(err);
    },
    onClickLeft() {
      this.$router.go(-1)
    },
    // 订单选择确认
    onOrderConfirm(value, index) {
      console.log(value)
      this.selectedOrderVaL = value.text
      this.selectedOrder = value.value
      this.showOrderPicker = false
    },
  }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/feedback_order.vue